/**
 * 登録可能マークファイル一覧
 *
 * @export MarkFileListVo
 * @class MarkFileListVo
 */
export class MarkFileListVo {
    constructor(
        public markCode: string,
        public markCodeBranch: string,
        public markFileName: string,
        public markFileUrl: string,
        public markGroupCode: string,
        public markGroupName: string,
        public markName: string,
        public supplyPromoteMarkDiv: string,
        public supplyPromoteMarkDivName: string,
        public registDate: string,
    ) {}
}
